<nav class="sidebar" [ngClass]="{ 'mobile': isMobile, 'open': opened }">

  @if (isMobile) {
  <div class="side-top">
    <img src="assets/images/logo.png" alt="VAPT" class="logo--small" />
    <button class="hamburger" type="button" aria-label="Fechar menu" (click)="close.emit()">
      <i class="fa-solid fa-bars"></i>
    </button>
  </div>
  } @else {
  <img src="assets/images/logo.png" alt="VAPT" class="logo" />
  }


  <ul class="menu">
    @for (item of filteredItems; track item; let i = $index) {
    <li>
      <div class="menu-item" (click)="toggleExpand(i)">
        <i class="{{ item.icon }}"></i>

        <span class="menu-title">
          {{ translate.stream(item.titleKey || item.title) | async }}
        </span>



        <i class="chevron" [ngClass]="{ 'open': expandedStates[i] }"></i>
      </div>

      @if (item.children && expandedStates[i]) {
      <ul class="submenu">
        @for (child of item.children; track child) {
        <li>
          <a [routerLink]="child.route" routerLinkActive="active" (click)="navigate.emit()">
            {{ (child.titleKey || child.title) | translate }}
          </a>
        </li>
        }
      </ul>
      }
    </li>
    }
  </ul>

  @if (isMobile) {
  <div class="sidebar-footer">
    <div class="footer-left">
      <app-avatar [size]="28" [cursor]="false" [altText]="displayName" [imageUrl]="displayImageUrl"></app-avatar>
      <span class="name">{{ displayName }}</span>
    </div>
    <a class="logout" href="/login">
      {{ translate.stream('LOGOUT') | async }}
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
    </a>
  </div>
  }

  <div class="sidebar-version">
    <small class="version">v.{{ version }}</small>
  </div>

</nav>